module.exports = __webpack_public_path__ + "img/107007.9fdda3b1.png";